.banner {
  width: 100%;
  height: 300px;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  background: rgba(0, 0, 0, 0.5); /* Optional overlay for contrast */
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 1200px;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/oekfbbucket.appspot.com/o/adminfiles%2FWhatsApp%20Image%202025-05-02%20at%2017.47.05.jpeg?alt=media&token=41a38094-8c88-4c56-82ae-4da8cbca1bba");
  background-size: cover;
  background-position: center;
  margin: 14px;
}

.overlay {
  background: rgba(0, 0, 0, 0.4); /* Optional overlay for contrast */
  padding: 40px;
  width: 100%;
}

.textBlock {
  color: white;
  max-width: 400px;
}

.heading {
  font-size: 1.75rem;
  font-weight: bolder;
  max-width: 60%;
  margin-bottom: 20px;
  line-height: 1.2;
  font-family: "Inter", Helvetica;
  font-weight: 400;
}

.downloadBtn {
  background-color: white;
  color: black;
  font-weight: bold;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.downloadBtn:hover {
  background-color: #f0f0f0;
}
